module.exports = __webpack_public_path__ + "img/m-hd.d3afd4be.webp";